import SiafLiteApiRepository from "../../external/siafLiteApi";

class BoletoService {
  constructor() {
    this.urlBase = "/financeiro/boletos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}`).post(body);
  }

  cadastrarLote(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/lote`).post(body);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  update(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).putBase("", body);
  }
}

export default BoletoService;
